<template>
  <b-nav-item-dropdown right class="dd-right">
    <template slot="button-content">
      <v-gravatar :email="currentUserEmail" class="img-avatar" :alt="currentUserEmail"/>
      <span class="name">{{ currentUserEmail.split('@')[0] }}</span>
    </template>
    <b-dropdown-item to="/profile">
      <div class="dd-icon" v-html="svg.ddUser"></div><span class="dd-text"> {{$t('HEADER.PROFILE') }}</span>
    </b-dropdown-item>
    <b-dropdown-item to="/super_admin/accounts" v-if="isSuperAdmin">
      <div class="dd-icon" v-html="svg.ddAccounts"></div><span class="dd-text"> {{ $t('HEADER.ACCOUNTS') }}</span>
    </b-dropdown-item>
    <b-dropdown-item to="/super_admin/features" v-if="isSuperAdmin">
      <div class="dd-icon" v-html="svg.featureflag"></div><span class="dd-text"> {{ $t('HEADER.Features') }}</span>
    </b-dropdown-item>
    <b-dropdown-item to="/super_admin/models" v-if="isSuperAdmin">
      <div class="dd-icon" v-html="svg.ddModels"></div><span class="dd-text"> {{ $t('HEADER.MODELS') }}</span>
    </b-dropdown-item>
    <b-dropdown-item to="/admin/users" v-if="isAdminRole">
        <div class="dd-icon" v-html="svg.ddAdmin"></div><span class="dd-text">{{ $t('HEADER.USERS') }}</span>
    </b-dropdown-item>
    <b-dropdown-item to="/audits/trail" v-if="isAdminRole">
        <div class="dd-icon" v-html="svg.history"></div><span class="dd-text">{{ $t('HEADER.LOGS') }}</span>
    </b-dropdown-item>
    <b-dropdown-item to="/settings/configure" v-if="isAdminRole">
        <div class="dd-icon" v-html="svg.ddSettings"></div><span class="dd-text">{{ $t('HEADER.SETTINGS') }}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="logOut" >
      <div class="dd-icon" v-html="svg.ddLogout"></div><span class="dd-text">{{ $t('HEADER.LOGOUT') }}</span>
      </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
  import { mapGetters } from 'vuex'
  import svg from '../../_svg.js'
  export default {
    name: 'micp-header-account',
    data () {
      return {
        svg: svg
      }
    },
    methods: {
      logOut: function () {
        this.$store.dispatch('logOut')
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSuperAdmin', 'currentUserEmail']),
      isAdminRole () {
        return this.isAdmin || this.isSuperAdmin
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue